const isKeyBoardContinuousChar = (str) => {
  var c1 = [
    ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '_', '+'],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '{', '}', '|'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ':', '"'],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm', '<', '>', '?']
  ];
  var c2 = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '='],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '[', ']', '\\'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ';', "'"],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/']
  ];
  str = str.toLowerCase().split('');
  //获取坐标位置
  var y = [];
  var x = [];
  for (var c = 0; c < str.length; c++) {
    y[c] = 0; //当做~`键处理
    x[c] = -1;
    for (var i = 0; i < c1.length; i++) {
      for (var j = 0; j < c1[i].length; j++) {
        if (str[c] == c1[i][j]) {
          y[c] = i;
          x[c] = j;
        }
      }
    }
    if (x[c] != -1) continue;
    for (var i = 0; i < c2.length; i++) {
      for (var j = 0; j < c2[i].length; j++) {
        if (str[c] == c2[i][j]) {
          y[c] = i;
          x[c] = j;
        }
      }
    }
  }
  //匹配坐标连线
  for (var c = 1; c < str.length - 1; c++) {
    if (y[c - 1] == y[c] && y[c] == y[c + 1]) {
      if (
        (x[c - 1] + 1 == x[c] && x[c] + 1 == x[c + 1]) ||
        (x[c + 1] + 1 == x[c] && x[c] + 1 == x[c - 1])
      ) {
        return true;
      }
    } else if (x[c - 1] == x[c] && x[c] == x[c + 1]) {
      if (
        (y[c - 1] + 1 == y[c] && y[c] + 1 == y[c + 1]) ||
        (y[c + 1] + 1 == y[c] && y[c] + 1 == y[c - 1])
      ) {
        return true;
      }
    }
  }
  return false;
};

const defaultOptions = [
  {
    id: 0,
    value: 'Too weak',
    minDiversity: 0,
    minLength: 0
  },
  {
    id: 1,
    value: 'Weak',
    minDiversity: 2,
    minLength: 6
  },
  {
    id: 2,
    value: 'Medium',
    minDiversity: 4,
    minLength: 8
  },
  {
    id: 3,
    value: 'Strong',
    minDiversity: 4,
    minLength: 10
  }
];

const passwordStrength = (
  password,
  options = defaultOptions,
  allowedSymbols = '!"#$%&\'()*+,-./:;<=>?@[\\\\\\]^_`{|}~',
  sensitiveWords = [],
  lang = 'zh-CN' // 'zh-CN' | 'en-US'
) => {
  let passwordCopy = password || '';
  sensitiveWords = Array.from(
    new Set(['admin', 'root', 'cmcc', 'cmss', 'linux', ...sensitiveWords])
  );

  options[0].minDiversity = 0;
  options[0].minLength = 0;

  const rules = [
    {
      regex: '[a-z]',
      message: 'lowercase'
    },
    {
      regex: '[A-Z]',
      message: 'uppercase'
    },
    {
      regex: '[0-9]',
      message: 'number'
    }
  ];

  if (allowedSymbols) {
    rules.push({
      regex: `[${allowedSymbols}]`,
      message: 'symbol'
    });
  }

  const forbids = [
    {
      regex: '^[0-9]*$',
      message: 'all numbers'
    },
    {
      regex: `${sensitiveWords.join('|')}/i`,
      type: 'array',
      message: lang === 'zh-CN' ? '含敏感词' : 'Contains offensive words'
    },
    {
      function: isKeyBoardContinuousChar,
      message: lang === 'zh-CN' ? '键盘连续' : 'Keyboard Continuous'
    }
  ];

  let strength = {};

  strength.contains = rules
    .filter((rule) => new RegExp(`${rule.regex}`).test(passwordCopy))
    .map((rule) => rule.message);

  strength.length = passwordCopy.length;

  strength.forbids = forbids
    .filter((forbid) => {
      const type = Object.keys(forbid)[0];

      switch (type) {
        case 'regex':
          return new RegExp(`${forbid.regex}`).test(passwordCopy);
        case 'function':
          return forbid.function(passwordCopy);
      }
    })
    .map((forbid) => forbid.message);

  let fulfilledOptions = options
    .filter((option) => strength.contains.length >= option.minDiversity)
    .filter((option) => strength.length >= option.minLength)
    .sort((o1, o2) => o2.id - o1.id)
    .map((option) => ({ id: option.id, value: option.value }));

  if (strength.forbids.length > 0) {
    fulfilledOptions.unshift(options[0]);
  }

  Object.assign(strength, fulfilledOptions[0]);

  return strength;
};

module.exports = { passwordStrength, defaultOptions };
